// extracted by mini-css-extract-plugin
export default {"split-button":"CorporateSplitButton_split-button__xYUXh"};